export default "__VITE_ASSET__ERnwH5vS__"